import { Component, OnInit, NgZone, ElementRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { debounceTime, takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';


@Component({
	selector: 'app-back-to-top',
	templateUrl: './back-to-top.component.html',
	styleUrls: ['./back-to-top.component.scss']
})
export class BackToTopComponent implements OnInit, OnDestroy {
	milesBarHeight$: Observable<number> = this.store.select(fromStore.getMilesBarHeight);
	milesBarHeight: number;

	constructor(private zone: NgZone, private store: Store<fromStore.State>) {
		this.milesBarHeight$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(milesBarHeight => this.milesBarHeight = milesBarHeight);
	}

	@ViewChild('backTop') $backTop: ElementRef;


	isScrolled = false;
	didScrollUp = false;
	showAtPossition = 80;
	lastScrollTop = 0;
	isScrolling = false;
	scrollingTimeout;
	brighter = false;
	isAlive = true;

	get bottomGapValue(): any {
		return {
				'transform': 'translateY(-' + this.milesBarHeight + 'px)'
			};
	}

	private scrollSubject = new Subject();

	ngOnInit() {
		const self = this;
		// Avoid over calculations from Angular by checking for changes on scroll
		this.zone.runOutsideAngular(() => {
			window.addEventListener('scroll', this.updateScroll.bind(self));
		});

		this.scrollSubject.pipe(debounceTime(75)).subscribe(() => (this.onScroll.bind(self))());
	}

	updateScroll(e) {
		this.scrollSubject.next(e);
	}

	onScroll() {
		const top = window.scrollY === undefined ? window.pageYOffset : window.scrollY;

		if (top < this.lastScrollTop) {
			this.didScrollUp = true;
		} else {
			this.didScrollUp = false;
		}

		if (top > this.showAtPossition) {
			this.isScrolled = true;
		} else {
			this.isScrolled = false;
		}

		this.lastScrollTop = top;

		if (this.isScrolled) {
			this.$backTop.nativeElement.className += this.$backTop.nativeElement.className.includes('is-scrolled') ? '' : ' is-scrolled ';
		} else {
			this.$backTop.nativeElement.className = this.$backTop.nativeElement.className.replace('is-scrolled', '');
		}

		if (this.didScrollUp) {
			this.$backTop.nativeElement.className += this.$backTop.nativeElement.className.includes('show-label') ? '' : ' show-label ';
		} else {
			this.$backTop.nativeElement.className = this.$backTop.nativeElement.className.replace('show-label', '');
		}

		this.$backTop.nativeElement.className = this.$backTop.nativeElement.className.trim();
	}

	/**
	 * Scroll to top page
	 */
	scrollToTop() {
		// window.scroll(0, 0);
		const elementBody = document.getElementsByTagName('body')[0];

		clearTimeout(this.scrollingTimeout);
		this.isScrolling = true;

		this.scrollingTimeout = setTimeout(() => {
			this.isScrolling = false;
		}, 600);
		elementBody.scrollIntoView({ block: 'start', behavior: 'smooth' });
	}

	getStyles() {
		return {
			'is-scrolled': this.isScrolled,
			'show-label': this.didScrollUp
		};
	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}
}
